import { mapGqlEntryBase, mapGqlRichText } from './gqlMapUtils'

function mapDataStripSection(entry, contentType) {
  if (!entry) {
    return null
  }

  return {
    ...mapGqlEntryBase(entry, contentType),
    id: entry.id ?? null,
    title: entry.title ?? null,
    content: mapGqlRichText(entry.content),
  }
}

export function mapDataStripGql(dataStrip) {
  if (!dataStrip) {
    return null
  }

  return {
    ...mapGqlEntryBase(dataStrip, 'dataStrip'),
    title: dataStrip.title ?? null,
    intro: mapDataStripSection(dataStrip.intro, 'dataStripIntro'),
    middle: mapDataStripSection(dataStrip.middle, 'dataStripMiddle'),
    next: mapDataStripSection(dataStrip.next, 'dataStripMid1'),
    ending: mapDataStripSection(dataStrip.ending, 'dataStripEnding'),
    source: mapDataStripSection(dataStrip.source, 'dataStripSource'),
  }
}

export function mapDataStripVariablesJsonGql(entry) {
  if (!entry) {
    return null
  }

  return {
    ...mapGqlEntryBase(entry, 'dataStripVariablesJson'),
    data: entry.data ?? null,
    month: entry.month ?? null,
  }
}
